import { useChartStore } from "@/stores/chartStore"

type ChartInstance = {
  getConvertPictureUrl?: (overlay?: boolean, type?: string, bg?: string) => string
  resize?: () => void
}

export function triggerSnapshot() {
  try {
    const container = document.getElementById("desktop-chart-surface")
    if (!container) return

    const chart = (window as unknown as Record<string, unknown>).__LYTICK_CHART__ as ChartInstance | null

    const symbol = useChartStore.getState().symbol
    const ts = new Date().toISOString().replace(/[:.]/g, "-").slice(0, 19)
    const filename = `lytick-${symbol}-${ts}.png`

    if (chart?.getConvertPictureUrl) {
      const EXPORT_SCALE = 3
      const nativeRatio = window.devicePixelRatio || 1
      const targetRatio = Math.max(EXPORT_SCALE, nativeRatio)
      const originalDescriptor = Object.getOwnPropertyDescriptor(window, "devicePixelRatio")

      let url: string
      try {
        // Temporarily raise pixel ratio so klinecharts panes re-render sharp
        Object.defineProperty(window, "devicePixelRatio", {
          configurable: true,
          get: () => targetRatio,
        })
        chart.resize?.()
        url = chart.getConvertPictureUrl(true, "png", "#080D17")
      } finally {
        // Always restore to the original state
        if (originalDescriptor) {
          Object.defineProperty(window, "devicePixelRatio", originalDescriptor)
        } else {
          // devicePixelRatio wasn't an own property before — just delete the shim
          try {
            // @ts-expect-error — deleting a configurable property
            delete window.devicePixelRatio
          } catch {
            // some environments won't allow delete; leave as-is
          }
        }
        chart.resize?.()
      }

      const a = document.createElement("a")
      a.href = url!
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } else {
      const canvas = container.querySelector("canvas")
      if (canvas) {
        const url = canvas.toDataURL("image/png")
        const a = document.createElement("a")
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    }
  } catch {
    // silently fail
  }
}

export function triggerShare() {
  try {
    const { symbol, timeframe } = useChartStore.getState()
    const url = new URL(window.location.href)
    url.searchParams.set("symbol", symbol)
    url.searchParams.set("tf", timeframe)
    void navigator.clipboard.writeText(url.toString()).then(() => {
      window.dispatchEvent(
        new CustomEvent("lytick:toast", {
          detail: { message: "Link copied", type: "success" },
        }),
      )
    })
  } catch {
    // silently fail
  }
}

// Register global event listeners so CommandPalette can dispatch lytick:snapshot / lytick:share
if (typeof window !== "undefined") {
  window.addEventListener("lytick:snapshot", triggerSnapshot)
  window.addEventListener("lytick:share", triggerShare)
}
